module.exports = __webpack_public_path__ + "img/icon-color-cancel.2fe5d3d0.svg";